const configuredBackend = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");

// With no explicit production backend, keep API/media requests same-origin.
// The CRACO dev server proxies these paths to the local backend, so a phone
// never resolves 127.0.0.1 as itself and auth cookies remain first-party.
export const backendUrl = configuredBackend;
